// Importing necessary action type constants
import * as ACTION from '../../Redux.constants';

/**
 * ShowLevelSelectorReducer
 * A reducer function to manage the state of the level selector's visibility status.
 * 
 * @param {boolean} state - Represents the current visibility state of the level selector. 
 *                          Initially set to true, indicating the level selector is visible.
 * @param {Object} action - Represents the dispatched action.
 * @returns {boolean} - Returns the new visibility state of the level selector based on the action.
 */
export function ShowLevelSelectorReducer(state = true, action) {
  switch (action.type) {
    // When a level is set, update the state to false to hide the level selector.
    case ACTION.SET_LEVEL:
      return false;

    // For any other action, simply return the current state.
    default:
      return state;
  }
}
